<template>

  <TableTemplate
    v-model="tableResult"

    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :skeletonClass="skeletonClass"
    :selected="selected"
    :enable-sorting="true"

    :remove-checkboxes="true"

    :page="page"
    :max="max"

    :on-row-click="showCustomerInformation"
    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Groothandel Klantenoverzicht"
        :show-button="showButton"
        :alwaysShowMultiSelectCheckbox="true"
        :exportParams="exportEndpointParams"
        :refetch="refetch"
        @setting-layout="customizeSetting"
        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <FormSearchSelector v-if="wholesaleCustomers"
          v-model="site"
          class="ml-2 website-search"
          id="website"
          placeholder="Zoek website..."
          endpoint="/api/websites"
          titleField="domainname"
          searchParameter="name"
          @select-item="setWebsiteParam"

          :infinite-scrolling="true"
          :table="true"

          v-slot="item"
        >
          <div class="p-1 item">
            {{ item.domainname }}
          </div>
        </FormSearchSelector>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>

      <CardTabs
        class="card-tabs"
        v-model="state"
        :tabs="tabs"
      />
    </template>

    <template v-if="wholesaleCustomers" #cell-customer_group="{ item }">
      <CustomerWholesaleToggle
        :customer_group="item.customer_group"
        :magento_id="item.magento_id"

        @click.native.stop
      />
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen klanten"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>

  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import FormButtonCheckbox from "src/components/Inputs/FormButtonCheckbox.vue"
import EditablePrice from '../layout/EditTableItem/EditablePrice.vue'
import MultipleSelectOptions from '../layout/Table/MultipleSelectOptions.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'
import CustomerWholesaleToggle from "@/components/CustomerWholesaleToggle";
import FormSearchSelector from '../components/Inputs/FormSearchSelector.vue'
import CardTabs from "@/layout/CardTabs"

import HeaderButton from "src/components/Inputs/HeaderButton.vue"

import table from "src/mixins/table"
import selectMultipleItems from "src/mixins/selectMultipleItems"

export default {
  metaInfo: {
    title: "Klantoverzicht",
  },
  components: {
    CardTabs,
    CustomerWholesaleToggle,
    RefreshBtn,
    MultipleSelectOptions,
    TableCell,
    FormSearchSelector,
    TableHeader,
    TableMainSearchField,
    EditablePrice,
    TableSearchField,
    FormSelect,
    EmptyStatePlaceholder,
    TableTemplate,
    FormButtonCheckbox,
    HeaderButton,
    TableActionDropdown,
  },
  mixins: [
    selectMultipleItems,
    tableFieldOptions,
    table({
      pageReference: 'customer-overview',

      columnTranslationMaps: {
        "Voornaam": "firstName",
        "Achternaam": "lastName",
        "E-mail": "email",
        "Straat": "street",
        "Postcode": "postalCode",
        "Huisnummer": "houseNumber",
        "Huisnummer toevoeging": "houseNumberExtension",
        "Stad": "city",
        "Telefoon": "telephone",
        "Bedrijfsnaam": "houseNumberExtension",
        "BTW nummer": "vatId",
        "IBAN": "iban",
        "Winkel": "shopName",
        "Groep": "customer_group",
      },

      defaultColumns: [
        "Voornaam", "Achternaam", "E-mail", "Bedrijfsnaam", "Winkel", "Groep"
      ],
      disableAlphabeticalSort: true,
      columnConfigurationId: "customers-overview",
      params: {
        search: "",
        site: "",
      },
      page_size: 100,
      route: vm => vm.wholesaleCustomers ? "/api/wholesale/customers" : "/api/customers",
      routeTriggers: ['wholesaleCustomers'],
    }),
  ],
  data() {
    return {
      state: 'wholesale',
    }
  },
  methods: {
    setWebsiteParam(item) {
      if(!item) return;
      const { domainname } = item
      this.site = domainname
      return domainname
    },
    showCustomerInformation(item) {
      this.$pushModal({
        modal: "CustomerInformation",
        toBind: {
          item,
          isWholesale: this.wholesaleCustomers,
          callback: () => this.freshRefetch()
        },
      })
    },
  },
  computed: {
    wholesaleCustomers() {
      return this.state === "wholesale"
    },
    tabs() {
      return [
        {
          name: "Wholesale",
          id: "wholesale",
        },
        {
          name: "Non Wholesale",
          id: "non-wholesale",
        },
      ]
    },
  },
}

</script>

<style scoped>

.card-tabs {
  transform: translateY(9px);
}

.name-wrapper {
  color: currentColor;
}

.name-wrapper:hover {
  text-decoration: underline;
}

</style>
